import { render, staticRenderFns } from "./BottomButton.vue?vue&type=template&id=93a222be&scoped=true&"
import script from "./BottomButton.vue?vue&type=script&lang=js&"
export * from "./BottomButton.vue?vue&type=script&lang=js&"
import style0 from "./BottomButton.vue?vue&type=style&index=0&id=93a222be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a222be",
  null
  
)

export default component.exports